const prod = {
    url: {
        // API_URL: "http://localhost:5001",
        // API_URL: "https://nimdee.com/backend/api/v1",
        API_URL: "https://glo-backend.qwizfun.com"
    }
};
const dev = {
    url: {
        // API_URL: "https://afternoon-ridge-35420.herokuapp.com/https://nimdeewksht.sandbox.9ijakids.com/backend/api/v1",
        // API_URL: "https://nimdee.com/backend/api/v1",
        // API_URL: "http://localhost:5001"
        API_URL: "https://glo-backend.qwizfun.com"
    }
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;